import axios from "axios";

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

// 👉 Instance riêng để refresh token
const refreshClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

axiosClient.interceptors.response.use(
    (response) => response.data,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // ✅ Gọi refresh token bằng instance riêng
                await refreshClient.post("/auth/refresh-token");

                // ✅ Sau khi backend set cookie mới, gọi lại request cũ
                return axiosClient(originalRequest);
            } catch (refreshError) {
                console.warn("Refresh token thất bại:", refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
